/**
 * 封装Map的一些常见操作类
 * 2020年7月26日09:10:38 create by zcg
 * */
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import OlStyleStyle from 'ol/style/Style'
import OlStyleIcon from 'ol/style/Icon'
import OlFeature from 'ol/Feature'
import OlGeomPoint from 'ol/geom/Point'
// 用来添加相关文字描述的
import Text from 'ol/style/Text'
import Fill from 'ol/style/Fill'

import {loadWMS} from "./layerSource"

//地图定位图片
// import markIcon  from  "../icons/position_16.png"
import markIcon  from  "../icons/position_32.png"

/**
 * 根据图层名称查看图层对应的图层
 * 备注:图层必须有一个name属性
 * */
const getLayerByName =function (map,layerName) {
  let selectedLayer = undefined;
  const mapLayers = map.getLayers();
  mapLayers.forEach(item=>{
    //console.log("Layer name = ",item.name);
    if(item.name ==layerName)
    {
      selectedLayer = item;
    }
  });
  return selectedLayer;
};

export function mu_readLayerByName(map,layerName) {//打印地图图层名称
  let selectedLayer = undefined;
  const mapLayers = map.getLayers();
  mapLayers.forEach(item=>{
    //console.log("Layer name = ",item.name);
    if(item.name ==layerName)
    {
      selectedLayer = item;
    }
  });
  return selectedLayer;
}


export function mu_printMapLayers(map) {//打印地图图层名称
  const mapLayers = map.getLayers();
  mapLayers.forEach(item=>{
    console.log(item.name);
  });
}


export function mu_setLayerVisible(map,layerName,visible) {
  const selectedLayer = getLayerByName(map,layerName);
  if(selectedLayer!=undefined)
  {
    selectedLayer.setVisible(visible);
  }
}


export function mu_setMapCenter(map,center,zoom) {//设置地图中心点
  map.getView().setZoom(zoom);
  map.getView().setCenter(center);
}


export function mu_addVectorMarkerLayer(map) {//给地图添加标注图层
  let vectorMarkerLayer = new VectorLayer({
    source: new VectorSource({
      features: []
    })
  });
  vectorMarkerLayer.name="VectorMarkerLayer"; //这个名字很重要,是默认的名称
  map.addLayer(vectorMarkerLayer);
  return vectorMarkerLayer;
}


/**
 * @description: 给地图添加单一标注
 *
 * @param {Map} map 地图对象
 * @param {ol.layer.vector} markerLayer 标注类地图图层
 * @param {double} lon 经度
 * @param {double} lat 维度
 * @param {string} markText 标注下方的文字,默认为 Default Mark Text
 * @param {string} markTextColor : 标注文字颜色,默认为黄色
 * @param {number} markTextSize : 标注文字大小, 默认为17
 * @return void
 */
export function mu_addSingleMarker(map,
                                   markerLayer,
                                   lon,
                                   lat,
                                   markText="Default Marker Text",
                                   markTextColor="Yellow",
                                   markTextSize=20,
                                   zoom=10)
{

  //Clear Vector Marker Layer
  mu_clearVectorMarkerLayer(markerLayer);

  const coordinate = [lon,lat];
  var mapMarker = new OlFeature({type: 'icon', geometry: new OlGeomPoint(coordinate),
  });

  let markStyle = new OlStyleStyle({
    image: new OlStyleIcon({
      anchor:  [0.5, 1.4],
      src: markIcon
    })
  });

  let mText = new Text({
    font: markTextSize+'px Microsoft YaHei',
    text: markText,
    fill: new Fill({
      color: markTextColor
    }),
    offsetY: 5// 设置文字偏移量,

  });
  markStyle.setText(mText);

  // 设置文字style
  mapMarker.setStyle(markStyle);
  mapMarker.set("mType","mapMarker");

  markerLayer.getSource().addFeature(mapMarker);
  map.getView().setCenter(coordinate); //设置地图中心 不会卡死
  map.getView().setZoom(zoom);
}



export function mu_addSingleMarkerWithOptioanlParams(map, markerLayer, lon, lat,
                                                     {
                                                       markText="Default Marker Text",
                                                       markTextColor="Yellow",
                                                       markTextSize=20,
                                                       zoom=10,
                                                       mType,
                                                       attribute={}})
{

  //Clear Vector Marker Layer
  mu_clearVectorMarkerLayer(markerLayer);

  const coordinate = [lon,lat];
  var mapMarker = new OlFeature({type: 'icon', geometry: new OlGeomPoint(coordinate),
  });

  let markStyle = new OlStyleStyle({
    image: new OlStyleIcon({
      anchor:  [0.5, 1.4],
      src: markIcon
    })
  });

  let mText = new Text({
    font: markTextSize+'px Microsoft YaHei',
    text: markText,
    fill: new Fill({
      color: markTextColor
    }),
    offsetY: 5// 设置文字偏移量,

  });
  markStyle.setText(mText);

  // 设置文字style
  mapMarker.setStyle(markStyle);
  mapMarker.set("attribute",attribute);
  mapMarker.set("mType",mType);



  markerLayer.getSource().addFeature(mapMarker);
  map.getView().setCenter(coordinate); //设置地图中心 不会卡死
  map.getView().setZoom(zoom);
}


















export function mu_clearVectorMarkerLayer(markerLayer) {//清空地图标注图层
  markerLayer.getSource().clear();
}


/**
 * @description 读取鼠标选中的元素的经纬度坐标,然后返回经过平移后的经纬度坐标
 * @param {Object} map      地图对象
 * @param {Object} feature  鼠标选中的要素
 * @param {Object} offsetX  屏幕X轴(水平)偏移像素
 * @param {Object} offsetY  屏幕Y轴(垂直)偏移像素
 * @return {Array} 经纬度坐标
 * */
export function mu_readFeaturnCoodinate(map,feature,offsetX=0,offsetY=0) {

  console.log("mu_readFeaturnCoodinate = ",feature);

  const featurenGeometry = feature.getGeometry();
  let featurenCoordinate = featurenGeometry.getCoordinates();
  let featurn_pix = map.getPixelFromCoordinate(featurenCoordinate);
  featurn_pix[0] = featurn_pix[0]+offsetX;
  featurn_pix[1] = featurn_pix[1]+offsetY;
  featurenCoordinate = map.getCoordinateFromPixel(featurn_pix);
  return featurenCoordinate;
}

export function mu_getConvertFeaturnCoodinate(map,feature,offsetX=0,offsetY=0) {

  //console.log("mu_getConvertFeaturnCoodinate = ",feature);
  const featurenGeometry = feature.geometry;
  //console.log("featurenGeometry = ",featurenGeometry);
  let featurenCoordinate = featurenGeometry.coordinates;
  //console.log("featurenCoordinate = ",featurenCoordinate);
  let featurn_pix = map.getPixelFromCoordinate(featurenCoordinate);
  featurn_pix[0] = featurn_pix[0]+offsetX;
  featurn_pix[1] = featurn_pix[1]+offsetY;
  featurenCoordinate = map.getCoordinateFromPixel(featurn_pix);
  return featurenCoordinate;
}






/**
 * @description 动态更新WMS地图服务 ,图层不存在，加载Geoserer图层
 * @param {Object} map 地图对象
 * @param {Object} options
   * @param {string} name                 图层名称
   * @param {string} server geoserver     服务地址
   * @param {string} code geoserer        服务编码
   * @param {boolean} visible             图层可见性
 * */
export function mu_dynamicWMSLayers(map,options)
{
  console.log("动态更新WMS服务");
  const {name,server,code,visible} = options;//析构对象属性
  let mapLayer =  getLayerByName(map,name);
  if(visible)
  {
    console.log("visible = ",visible," &mapLayer = ",mapLayer);
    if(mapLayer==undefined)
    {
      console.log("Layer is not Exist & load map layer");
      mapLayer = loadWMS(visible,server,code,name);
      map.addLayer(mapLayer);
    }
  }
  else
  {
    console.log("visible = ",visible);
  }

  if(mapLayer!=undefined)
  {
    console.log("update map visible & visible = ",visible);
    mapLayer.setVisible(visible);
  }
  else {
    console.log("update map visible fail & mapLayer = ",mapLayer);
  }
}


/**
 * @description 查询Overlay图层服务
 * @param {Object} map 地图对象
 * @param {String} options_key 检索key
 * @param {String} options_value 检索值
 * */
export function mu_clearMeasureOverlay(map,options_value) {
  const overlay_key = "olName";
  let overlays = map.getOverlays();
  console.log(overlays);
  overlays.forEach(item=>{
    let overlay_options = item.options;
    let options_key_values = overlay_options[overlay_key];
    if(options_key_values!=undefined &&options_key_values==options_value)
    {
      item.setPosition(undefined);
    }
  });
}



/**
 * @description 设置图层位置
 * @param {Object} map 地图对象
 * @param {String} options_key 检索key
 * @param {String} options_value 检索值
 * */
export function mu_setLayerIndex(map,layer_name,layer_index) {
  let selectedLayer = getLayerByName(map,layer_name);
  selectedLayer.setZIndex(layer_index);
}








// WEBPACK FOOTER //
// ./src/components/map/common/MapUtils.js